import type { ThemeConfig } from "antd";

import type { ThemeMode } from "../ThemeModeProvider";
import { darkTheme } from "./dark";
import { lightTheme } from "./light";

export const getV6ThemeConfig = (mode: ThemeMode): ThemeConfig => (mode === "dark" ? darkTheme : lightTheme);

export const v6ThemeConfig = lightTheme;
